const getBorderRadius = (computedStyles, widthContainer, heightContainer) => {
  const { borderRadius } = computedStyles;
  const percent = /%/;

  const borderRadiusGroups = borderRadius.split('/');
  const borderRadiuses = borderRadiusGroups.map((group, index) => {
    const radiuses = group.trim().split(' ');
    const convertedRadiuses = radiuses.map((radius) => {
      if (radius.match(percent)) {
        let axis;
        if (index === 0) axis = widthContainer; // it is x-axis
        if (index === 1) axis = heightContainer; // it is y-axis

        // we convert percentage values to pixels,
        // since percentage value in svg is calculated relative to svg itself
        return (parseFloat(radius) * axis) / 100;
      }

      return parseFloat(radius);
    });

    // we need only one border-radius value,
    // since we can't set different values for each corner separately in svg
    return `${Math.max(...convertedRadiuses)}px`;
  });

  return {
    borderRadiusAxisX: borderRadiuses[0],
    borderRadiusAxisY: borderRadiuses[1] || borderRadiuses[0],
  };
};

export default getBorderRadius;
